import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
} from "reactstrap";
import { useSafariPaymentReset } from "../../../hooks/useSafariPaymentReset";
import CustomInput from "../../../custom/CustomInput";
import CustomSelect from "../../../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch, batch } from "react-redux";
import CircularLoading from "../../loader/CircularIndeterminate";
import { Autocomplete, TextField } from "@mui/material";

const VogaOptionTwo = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);
  // const { courses } = useSelector((state) => state.courses);

  // useEffect(() => {
  //   dispatch(actions.coursesGetData());
  //   dispatch(actions.batchesGetData());
  // }, []);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const coursereg = {
      clientname: values.clientname,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      age: values.age,
      course_id: values.course_id,
      month: values.month,
      totalfees: values.totalfees,
      batch_name: values.batch_name,
      is_enquiry: values.is_enquiry,
      is_online_payment: values.is_online_payment,
    };
    // iOS Safari compatible redirect
    dispatch(
      actions.postCourseregDataWithBackendRedirect(coursereg, setSubmitting, resetForm)
    );
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for batches.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  clientemail: "",
                  clientphone: "",
                  age: "",
                  course_id: "411",
                  month: "",
                  // number_of_month: "",
                  batch_name: "",
                  totalfees: "",
                  is_enquiry: "0",
                  is_online_payment: "1",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                  course_id: Yup.string().required("required"),
                  month: Yup.string().required("required"),
                })}
              >
                {(formProps) => {
                  const selectedMonth = formProps.values.month;
                  const price = selectedMonth.match(/(\d+)$/);
                  formProps.values.totalfees = formProps.values.month * 999;
                  formProps.values.totalfees = price ? price[1] : "";
                  return (
                    <Form className="mt-3">
                      {console.log("formProps", formProps.values)}
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="clientname" className="label">
                            Your Full Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientname"
                              id="clientname"
                              placeholder="Enter Your Name"
                              className={
                                "form-control" +
                                (formProps.errors.clientname &&
                                formProps.touched.clientname
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientname"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="clientemail" className="label">
                            Your Email:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientemail"
                              id="clientemail"
                              placeholder="Enter Your Email"
                              className={
                                "form-control" +
                                (formProps.errors.clientemail &&
                                formProps.touched.clientemail
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientemail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="clientphone" className="label">
                            Your Whatsapp Number:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientphone"
                              id="clientphone"
                              placeholder="Enter Your Whatsapp Number"
                              className={
                                "form-control" +
                                (formProps.errors.clientphone &&
                                formProps.touched.clientphone
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientphone"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="age" className="label">
                            Your Age:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="age"
                              id="age"
                              placeholder="Enter Your Age"
                              className={
                                "form-control" +
                                (formProps.errors.age && formProps.touched.age
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="age"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      {/* number_of_month */}
                      {/* <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="number_of_month" className="label">
                            Minimum number of months for riyaaz:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="number_of_month"
                              id="number_of_month"
                              placeholder="Enter Minimum number of months for riyaaz"
                              className={
                                "form-control" +
                                (formProps.errors.number_of_month &&
                                formProps.touched.number_of_month
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="number_of_month"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row> */}
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="month" className="label">
                            Number of months:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="month"
                              id="month"
                              placeholder="Enter Number of months"
                              className={
                                "form-control" +
                                (formProps.errors.month &&
                                formProps.touched.month
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>
                                Select Number of months
                              </option>
                              <option value={"999"}>1 Month</option>
                              <option value={"1799"}>
                                2 Months
                              </option>
                              <option value={"2599"}>
                                3 Months
                              </option>
                            </Field>
                            <ErrorMessage
                              name="month"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="batch_name" className="label">
                            Select Your Batch:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="batch_name"
                              id="batch_name"
                              placeholder="Enter Your Batch"
                              className={
                                "form-control" +
                                (formProps.errors.batch_name &&
                                formProps.touched.batch_name
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>Select Your Batch</option>
                              <option value={"Mon-Wed-Fri (Morning 7 AM)"}>
                                Mon-Wed-Fri (Morning 7 AM)
                              </option>
                              <option value={"Mon-Wed-Fri (Evening 5 PM)"}>
                                Mon-Wed-Fri (Evening 5 PM)
                              </option>
                            </Field>
                            <ErrorMessage
                              name="batch_name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="totalfees" className="label">
                            Your Amount:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              disabled
                              name="totalfees"
                              id="totalfees"
                              placeholder="Enter Amount"
                              className={
                                "form-control" +
                                (formProps.errors.totalfees &&
                                formProps.touched.totalfees
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            {/* <option value={""}>Select Number of months</option>
                            <option value={"999"}>999</option>
                            <option value={"1799"}>1799</option>
                            <option value={"2599"}>2599</option> */}
                            <ErrorMessage
                              name="totalfees"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>

                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <InputGroup>
                            <Field type="checkbox" name="checked" value="One" />

                            <span className="radiobtn">
                              {" "}
                              &nbsp; Hereby,Please Accept Terms & Condition
                            </span>
                            <ErrorMessage
                              name="branch"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      {/* <h4 className="text-center p-3 mt-3">
                      To register for Voga Experience (Level 1), Kindly contact
                      us at +91 7400 377748
                    </h4> */}
                      <div className="mt-3 mb-3 row mt-3">
                        <div className="col-12">
                          <Button
                            type="submit"
                            className="register-btn"
                            size="md"
                            block
                          >
                            {isPostLoading ? <CircularLoading /> : "PAY NOW"}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default VogaOptionTwo;
